import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { getClassOfServiceColor, getClassOfServiceFontColor } from 'utils/classOfService';

import { StyledArrowRight } from 'components/shared/JourneyDigest/JourneyDigest.styles';
import { StyledDates } from '../ExchangeSummary.styles';
import { StyledExchangeSummaryOD } from './ExchangeSummaryOD.styles';

const ExchangeSummaryOD = ({ date, originName, destinationName, journeyLength, classOfService }) => {
  const bgColor = getClassOfServiceColor(classOfService?.code);
  const fontColor = getClassOfServiceFontColor(classOfService?.code);

  return (
    <StyledExchangeSummaryOD bgColor={bgColor} fontColor={fontColor}>
      <StyledDates data-testid="travel-date">{moment(date).format('dddd Do MMM YYYY')}</StyledDates>
      <p>
        <span data-id="origin-name" data-testid="origin-name">
          {originName}
        </span>
        <StyledArrowRight />
        <span data-id="destination-name" data-testid="destination-name">
          {destinationName} - {journeyLength}
        </span>{' '}
        <FormattedMessage id="journeySummary.pax" />
      </p>
    </StyledExchangeSummaryOD>
  );
};

ExchangeSummaryOD.propTypes = {
  date: PropTypes.string,
  originName: PropTypes.string,
  destinationName: PropTypes.string,
  journeyLength: PropTypes.number,
  classOfService: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string
  })
};

export default ExchangeSummaryOD;
